import { render, staticRenderFns } from "./DevelopmentMenu.vue?vue&type=template&id=eb58eac6&scoped=true"
import script from "./DevelopmentMenu.vue?vue&type=script&lang=ts"
export * from "./DevelopmentMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb58eac6",
  null
  
)

export default component.exports